import { useHotkeys } from 'react-hotkeys-hook';

const Shortcut = ({ shortcut, handler }) => {
  useHotkeys(shortcut, handler, [handler]);
  return null;
};

export default Shortcut;
